import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import startOfWeek from 'date-fns/start_of_week';
import _ from 'lodash'
import { getTeamByCompany } from './core/cacheService';
export default {
    namespaced: true,
    state: {
        team_id:'',
        team:[],
        teamArr:[],
        mostengage:[],
        mostengageAll:[],
        mostengageRoot:[],
        retentionrisks:[],
        retentionrisksAll:[],
        retentionrisksRoot:[],
        mostimprove:[],
        mostimproveAll:[],
        mostimproveRoot:[],
        mostcritical:[],
        mostcriticalAll:[],
        mostcriticalRoot:[],
        mostactivemanagers:[],
        mostactivemanagersAll:[],
        mostactivemanagersRoot:[],
        mostinactivemanagers:[],
        mostinactivemanagersAll:[],
        mostinactivemanagersRoot:[],
        inputSearch: '',
        dateshow:'',
    },
    mutations: {
        setTeam(state:any, result:any) {
            state.team = result
        },
        setTeamArr(state:any, result:any) {
            state.teamArr = result
        },
        setMostEngage(state:any, result:Array<any>) {
            let num=1
            Object.entries(result).forEach(([key, value]) =>{ 
                _.set(value,'no', num++);
            });
            state.mostengage = result
        },
        setMostEngageCheck(state:any, result:Array<any>) {
            let num=1
            let temp_result:Array<any> = []
            Object.entries(result).forEach(([key, value]) =>{
                if(value['score'] >= 0){
                    _.set(value,'no', num++);
                    _.set(temp_result,key,value);
                } 
            });
            state.mostengage = temp_result
        },
        setMostEngageAll(state:any, result:any) {
            state.mostengageAll = result
        },
        setMostEngageRoot(state:any, result:any) {
            state.mostengageRoot = result
        },
        setRetentionRisks(state:any, result:Array<any>) {
            let num=1
            Object.entries(result).forEach(([key, value]) =>{ 
                _.set(value,'no', num++);
            });
            state.retentionrisks = result
        },
        setRetentionRisksCheck(state:any, result:Array<any>) {
            let num=1
            let temp_result:Array<any> = []
            Object.entries(result).forEach(([key, value]) =>{
                if(value['score'] <= 0){
                    _.set(value,'no', num++);
                    _.set(temp_result,key,value);
                } 
            });
            state.retentionrisks = temp_result
        },
        setRetentionRisksAll(state:any, result:any) {
            state.retentionrisksAll = result
        },
        setRetentionRisksRoot(state:any, result:any) {
            state.retentionrisksRoot = result
        },
        setMostImprove(state:any, result:Array<any>) {
            let num=1
            Object.entries(result).forEach(([key, value]) =>{ 
                _.set(value,'no', num++);
            });
            state.mostimprove = result 
        },
        setMostImproveCheck(state:any, result:Array<any>) {
            let num=1
            let temp_result:Array<any> = []
            Object.entries(result).forEach(([key, value]) =>{
                if(value['score'] > 0){
                    _.set(value,'no', num++);
                    _.set(temp_result,key,value);
                } 
            });
            state.mostimprove = temp_result
        },
        setMostImproveAll(state:any, result:any) {
            state.mostimproveAll = result
        },
        setMostImproveRoot(state:any, result:any) {
            state.mostimproveRoot = result
        },
        setMostCritical(state:any, result:Array<any>) {
            let num=1
            Object.entries(result).forEach(([key, value]) =>{ 
                _.set(value,'no', num++);
            });
            state.mostcritical = result
        },
        setMostCriticalCheck(state:any, result:Array<any>) {
            let num=1
            let temp_result:Array<any> = []
            Object.entries(result).forEach(([key, value]) =>{
                if(value['score'] < 0){
                    _.set(value,'no', num++);
                    _.set(temp_result,key,value);
                } 
            });
            state.mostcritical = temp_result
        },
        setMostCriticalAll(state:any, result:any) {
            state.mostcriticalAll = result
        },
        setMostCriticalRoot(state:any, result:any) {
            state.mostcriticalRoot = result
        },
        setMostActivemanagers(state:any, result:Array<any>) {
            let num=1
            Object.entries(result).forEach(([key, value]) =>{ 
                _.set(value,'no', num++);
            });
            state.mostactivemanagers = result
        },
        setMostActivemanagersCheck(state:any, result:Array<any>) {
            let num=1
            let temp_result:Array<any> = []
            Object.entries(result).forEach(([key, value]) =>{
                if(value['score'] > 0.4){
                    _.set(value,'no', num++);
                    _.set(temp_result,key,value);
                } 
            });
            state.mostactivemanagers = temp_result
        },
        setMostActivemanagersAll(state:any, result:any) {
            state.mostactivemanagersAll = result
        },
        setMostActivemanagersRoot(state:any, result:any) {
            state.mostactivemanagersRoot = result
        },
        setMostInActivemanagers(state:any, result:Array<any>) {
            let num=1
            Object.entries(result).forEach(([key, value]) =>{ 
                _.set(value,'no', num++);
            });
            state.mostinactivemanagers = result
        },
        setMostInActivemanagersCheck(state:any, result:Array<any>) {
            let num=1
            let temp_result:Array<any> = []
            Object.entries(result).forEach(([key, value]) =>{
                if(value['score'] <= 0.4){
                    _.set(value,'no', num++);
                    _.set(temp_result,key,value);
                } 
            });
            state.mostinactivemanagers = temp_result
        },
        setMostInActivemanagersAll(state:any, result:any) {
            state.mostinactivemanagersAll = result
        },
        setMostInActivemanagersRoot(state:any, result:any) {
            state.mostinactivemanagersRoot = result
        },
        setTeamId(state:any,value:any) {
            state.team_id = value.keyword
        },
        setinputSearch(state:any,value:any) {
            state.inputSearch = value.keyword
        },
        setDateShow(state:any,result:string){
            state.dateshow = result
        }
    },
    actions: {
        async getTeam({commit,dispatch}:any, user:any){
            const dateNow = new Date()
            const teams:Array<any> = [];
            const parent:{ [key: string]: string} = {};
            var tempData = {};
            try{
                const teamData = await getTeamByCompany(user.company)
                for(const key in teamData){

                    const team = teamData[key]
                    team.key = key
                    teams.push(team)
                    tempData[team.key] = team
                    if(team.key) parent[team.key] = team.name

                }
                _.forEach(teams, (value,key)=> {
                    if(value.parent){
                        teams[key].parent_name = parent[value.parent]
                    }else{
                        teams[key].parent_name = '';
                    }
                });
                commit('setTeamArr', _.sortBy(teams, [function(o:any) { return o.name; }]))
                commit('setTeam', tempData)
                //let startdate = moment().add(-7, 'days').tz("Asia/Bangkok").startOf('isoWeek').format('MMM D')
                let startdate = format(startOfWeek(addDays(dateNow, -7),{weekStartsOn:1}), 'MMM D')
                //let enddate = moment().add(-7, 'days').tz("Asia/Bangkok").startOf('isoWeek').add(+4, 'days').format('MMM D')
                let enddate = format(startOfWeek(addDays(dateNow, -3),{weekStartsOn:5}), 'MMM D')
                commit('setDateShow',`${startdate} - ${enddate}`)
                dispatch('getMostEngage', user)
                dispatch('getRetentionRisks', user)
                dispatch('getMostImprove', user)


            }catch(error){
                console.log(error)
            }

            
            // firebase.database().ref().child('team').orderByChild('company').equalTo(`${user.company}`).once('value', snapshot => {
            //     const teams:Array<any> = [];
            //     const parent:{ [key: string]: string} = {};
            //     var tempData = {};
            //     snapshot.forEach((doc):any => {
            //         const team = doc.val()
            //         team.key = doc.key
            //         teams.push(team)
            //         tempData[team.key] = team
            //         if(doc.key) parent[doc.key] = doc.val().name
            //     });
            //     _.forEach(teams, (value,key)=> {
            //         if(value.parent){
            //             teams[key].parent_name = parent[value.parent]
            //         }else{
            //             teams[key].parent_name = '';
            //         }
            //     });
            //     commit('setTeamArr', _.sortBy(teams, [function(o:any) { return o.name; }]))
            //     commit('setTeam', tempData)
            //     //let startdate = moment().add(-7, 'days').tz("Asia/Bangkok").startOf('isoWeek').format('MMM D')
            //     let startdate = format(startOfWeek(addDays(dateNow, -7),{weekStartsOn:1}), 'MMM D')
            //     //let enddate = moment().add(-7, 'days').tz("Asia/Bangkok").startOf('isoWeek').add(+4, 'days').format('MMM D')
            //     let enddate = format(startOfWeek(addDays(dateNow, -3),{weekStartsOn:5}), 'MMM D')
            //     commit('setDateShow',`${startdate} - ${enddate}`)
            //     dispatch('getMostEngage', user)
            //     dispatch('getRetentionRisks', user)
            //     dispatch('getMostImprove', user)
            //     // dispatch('getMostActivemanagers', user)
            // }).catch(error => {
            //     console.log(error)
            // });

            // const team = (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
            // commit('setTeam', team)
            // console.log('=========== setTeam ===========')
            // console.log(team)

         
        },
        getMostEngage({commit,state}:any, user:any){
            const dateNow = new Date()
            //let today = moment().add(-7, 'days').tz("Asia/Bangkok").format('YYYY-WW')
            let today = format(addDays(dateNow, -6), 'YYYY-WW')
            // today = '2018-34'
            firebase.firestore().collection('spotlight').where("type", "==",'most_engaged').where("date", "==",today).where("company", "==", user.company).orderBy('score', 'asc').get()
            .then((querySnapshot)=> {
                let list_MostEngage:Array<any> = []
                let list_MostEngage_root:Array<any> = []
                querySnapshot.forEach( (doc)=> {
                    // console.log(doc.data())
                    let temp_name = '';
                    let temp_name_parent = '';
                    if(state.team[doc.data().team]){
                    temp_name = state.team[doc.data().team].name
                    temp_name_parent = (state.team[doc.data().team].parent != "" ? state.team[ state.team[doc.data().team].parent ].name : "")
                    }
                    list_MostEngage.push({'teamid':doc.data().team,'team':temp_name,'team_name':temp_name_parent,'score':doc.data().score.toFixed(1) })

                    let temp = _.clone(doc.data())
                    _.set(temp,'team', temp_name);
                    _.set(temp,'team_name', temp_name_parent);
                    _.set(temp,'score', doc.data().score.toFixed(1));
                    if(doc.data().parent){
                        if(list_MostEngage_root[doc.data().parent] === undefined){
                            list_MostEngage_root[doc.data().parent] = new Array()
                        }
                        list_MostEngage_root[doc.data().parent].push(temp);
                    }
                    
                });
                // sort score in list_MostEngage_root
                Object.entries(list_MostEngage_root).forEach(([key, value]) =>{ 
                    _.sortBy(value,'score')
                    value.reverse()
                });
                
                list_MostEngage.reverse()
                commit('setMostEngageCheck', list_MostEngage.slice(0, 3))
                commit('setMostEngageAll', list_MostEngage)
                commit('setMostEngageRoot', list_MostEngage_root)
            });
        },
        getRetentionRisks({commit,state}:any, user:any){
            const dateNow = new Date()
            //let today = moment().add(-7, 'days').tz("Asia/Bangkok").format('YYYY-WW')
            let today = format(addDays(dateNow, -6), 'YYYY-WW')
            firebase.firestore().collection('spotlight').where("type", "==",'retention_risks').where("date", "==",today).where("company", "==", user.company).orderBy('score', 'asc').get()
            .then((querySnapshot)=> {
                let list_RetentionRisks:Array<any> = []
                let list_RetentionRisks_root:Array<any> = []
                querySnapshot.forEach( (doc)=> {
                    // console.log(doc.data())
                    let temp_name = '';
                    let temp_name_parent = '';
                    if(state.team[doc.data().team]){
                    temp_name = state.team[doc.data().team].name
                    temp_name_parent = (state.team[doc.data().team].parent != "" ? state.team[ state.team[doc.data().team].parent ].name : "")
                    }
                    list_RetentionRisks.push({'teamid':doc.data().team,'team':temp_name,'team_name':temp_name_parent,'score':doc.data().score.toFixed(1) })

                    let temp = _.clone(doc.data())
                    _.set(temp,'team', temp_name);
                    _.set(temp,'team_name', temp_name_parent);
                    _.set(temp,'score', doc.data().score.toFixed(1));
                    if(doc.data().parent){
                        if(list_RetentionRisks_root[doc.data().parent] === undefined){
                            list_RetentionRisks_root[doc.data().parent] = new Array()
                        }
                        list_RetentionRisks_root[doc.data().parent].push(temp);
                    }
                    
                });
                // sort score in list_MostEngage_root
                Object.entries(list_RetentionRisks_root).forEach(([key, value]) =>{ 
                    _.sortBy(value,'score')
                    // value.reverse()
                });
                commit('setRetentionRisksCheck', list_RetentionRisks.slice(0, 3))
                commit('setRetentionRisksAll', list_RetentionRisks)
                commit('setRetentionRisksRoot', list_RetentionRisks_root)
            });
        },
        getMostImprove({commit,state}:any, user:any){
            const dateNow = new Date()
            //let today = moment().add(-7, 'days').tz("Asia/Bangkok").format('YYYY-WW')
            let today = format(addDays(dateNow, -6), 'YYYY-WW')
            firebase.firestore().collection('spotlight').where("type", "==",'most_improved').where("date", "==",today).where("company", "==", user.company).orderBy('score', 'asc').get()
            .then((querySnapshot)=> {
                let list_MostImprove:Array<any> = []
                let list_MostImprove_root:Array<any> = []
                let list_MostCritical:Array<any> = []
                let list_MostCritical_root:Array<any> = []
                querySnapshot.forEach( (doc)=> {
                    // console.log(doc.data())
                    if(doc.data().status == 'none'){
                        let temp_name = '';
                        let temp_name_parent = '';
                        if(state.team[doc.data().team]){
                        temp_name = state.team[doc.data().team].name
                        temp_name_parent = (state.team[doc.data().team].parent != "" ? state.team[ state.team[doc.data().team].parent ].name : "")
                        }
                        list_MostImprove.push({'teamid':doc.data().team,'team':temp_name,'team_name':temp_name_parent,'score':doc.data().score.toFixed(1) })
                        list_MostCritical.push({'teamid':doc.data().team,'team':temp_name,'team_name':temp_name_parent,'score':doc.data().score.toFixed(1) })

                        let temp = _.clone(doc.data())
                        _.set(temp,'team', temp_name);
                        _.set(temp,'team_name', temp_name_parent);
                        _.set(temp,'score', doc.data().score.toFixed(1));
                        let temp2 = _.clone(temp)
                        if(doc.data().parent){
                            if(list_MostImprove_root[doc.data().parent] === undefined){
                                list_MostImprove_root[doc.data().parent] = new Array()
                                list_MostCritical_root[doc.data().parent] = new Array()
                            }
                            list_MostImprove_root[doc.data().parent].push(temp);
                            list_MostCritical_root[doc.data().parent].push(temp2);
                        }
                    }
                });
                // sort score in list_MostEngage_root
                Object.entries(list_MostImprove_root).forEach(([key, value]) =>{ 
                    _.sortBy(value,'score')
                    value.reverse()
                });
                list_MostImprove.reverse()
                commit('setMostImproveCheck', list_MostImprove.slice(0, 3))
                commit('setMostImproveAll', list_MostImprove)
                commit('setMostImproveRoot', list_MostImprove_root)
                commit('setMostCriticalCheck', list_MostCritical.slice(0, 3))
                commit('setMostCriticalAll', list_MostCritical)
                commit('setMostCriticalRoot', list_MostCritical_root)
            });
        },
      
        getMostActivemanagers({commit,state}:any, user:any){
            const dateNow = new Date()
            //let today = moment().add(-7, 'days').tz("Asia/Bangkok").format('YYYY-WW')
            let today = format(addDays(dateNow, -6), 'YYYY-WW')
            firebase.firestore().collection('spotlight').where("type", "==",'most_active_managers').where("date", "==",today).where("company", "==", user.company).orderBy('score', 'asc').get().then((querySnapshot)=> {
                //mostinactivemanagers
                // console.log(querySnapshot)
                let list_MostActivemanagers:Array<any> = []
                let list_MostInActivemanagers:Array<any> = []
                let list_MostActivemanagers_root:Array<any> = []
                let list_MostInActivemanagers_root:Array<any> = []
                querySnapshot.forEach( (doc)=> {
                        // console.log(doc.data())
                        let temp_name = '';
                        let temp_name_parent = '';
                        if(state.team[doc.data().team]){
                            temp_name = state.team[doc.data().team].name
                            temp_name_parent = (state.team[doc.data().team].parent != "" ? state.team[ state.team[doc.data().team].parent ].name : "")
                        }
                        list_MostActivemanagers.push({'teamid':doc.data().team,'team':temp_name,'team_name':temp_name_parent,'score':doc.data().score.toFixed(1) })
                        list_MostInActivemanagers.push({'teamid':doc.data().team,'team':temp_name,'team_name':temp_name_parent,'score':doc.data().score.toFixed(1) })

                        let temp = _.clone(doc.data())
                        _.set(temp,'team', temp_name);
                        _.set(temp,'team_name', temp_name_parent);
                        _.set(temp,'score', doc.data().score.toFixed(1));
                        let temp2 = _.clone(temp)
                        if(doc.data().parent){
                            if(list_MostActivemanagers_root[doc.data().parent] === undefined){
                                list_MostActivemanagers_root[doc.data().parent] = new Array()
                                list_MostInActivemanagers_root[doc.data().parent] = new Array()
                            }
                            list_MostActivemanagers_root[doc.data().parent].push(temp);
                            list_MostInActivemanagers_root[doc.data().parent].push(temp2);
                        }
                });
                // sort score in list_MostEngage_root
                Object.entries(list_MostActivemanagers_root).forEach(([key, value]) =>{ 
                    _.sortBy(value,'score')
                    value.reverse()
                });
                list_MostActivemanagers.reverse()
                commit('setMostActivemanagersCheck', list_MostActivemanagers.slice(0, 3))
                commit('setMostActivemanagersAll', list_MostActivemanagers)
                commit('setMostActivemanagersRoot', list_MostActivemanagers_root)
                commit('setMostInActivemanagersCheck', list_MostInActivemanagers.slice(0, 3))
                commit('setMostInActivemanagersAll', list_MostInActivemanagers)
                commit('setMostInActivemanagersRoot', list_MostInActivemanagers_root)
            });
           
        },
        async reponseSearchAll({state}:any){
            const dateNow = new Date()
            const data:Array<any> = []
            let list_MostEngage:Array<any> = []
            let list_RetentionRisks:Array<any> = []
            let list_MostImprove:Array<any> = []
            let list_MostCritical:Array<any> = []
            let list_MostActivemanagers:Array<any> = []
            let list_MostInActivemanagers:Array<any> = []
            let today = format(addDays(dateNow, -6), 'YYYY-WW')//moment().add(-7, 'days').tz("Asia/Bangkok").format('YYYY-WW')
            if(state.team_id && state.team_id.substring(0, 1) =='-'){
                // type : most_engaged
                if(state.mostengageRoot[state.team_id] !== undefined){
                    list_MostEngage = _.clone(state.mostengageRoot[state.team_id]);
                }else{
                    list_MostEngage = _.filter(state.mostengageAll, (item):any => {
                        if (item.teamid.match(state.team_id)){
                            return true
                        }
                    });
                }
                // type : retention_risk
                if(state.retentionrisksRoot[state.team_id] !== undefined){
                    list_RetentionRisks = _.clone(state.retentionrisksRoot[state.team_id]);
                }else{
                    list_RetentionRisks = _.filter(state.retentionrisksAll, (item):any => {
                        if (item.teamid.match(state.team_id)){
                            return true
                        }
                    });
                }
                // type : most_improved
                if(state.mostimproveRoot[state.team_id] !== undefined){
                    list_MostImprove = _.clone(state.mostimproveRoot[state.team_id]);
                }else{
                    list_MostImprove = _.filter(state.mostimproveAll, (item):any => {
                        if (item.teamid.match(state.team_id)){
                            return true
                        }
                    });
                }
                // type : most_critical
                if(state.mostcriticalRoot[state.team_id] !== undefined){
                    list_MostCritical = _.clone(state.mostcriticalRoot[state.team_id]);
                }else{
                    list_MostCritical = _.filter(state.mostcriticalAll, (item):any => {
                        if (item.teamid.match(state.team_id)){
                            return true
                        }
                    });
                }
                // type : most_activemanagers
                // if(state.mostactivemanagersRoot[state.team_id] !== undefined){
                //     list_MostActivemanagers = _.clone(state.mostactivemanagersRoot[state.team_id]);
                // }else{
                //     list_MostActivemanagers = _.filter(state.mostactivemanagersAll, (item):any => {
                //         if (item.teamid.match(state.team_id)){
                //             return true
                //         }
                //     });
                // }
                // type : most_inactivemanagers
                // if(state.mostinactivemanagersRoot[state.team_id] !== undefined){
                //     list_MostInActivemanagers = _.clone(state.mostinactivemanagersRoot[state.team_id]);
                // }else{
                //     list_MostInActivemanagers = _.filter(state.mostinactivemanagersAll, (item):any => {
                //         if (item.teamid.match(state.team_id)){
                //             return true
                //         }
                //     });
                // }
         
            }else{
                list_MostEngage = state.mostengageAll
                list_RetentionRisks = state.retentionrisksAll
                list_MostImprove = state.mostimproveAll
                list_MostCritical = state.mostcriticalAll
                // list_MostActivemanagers = state.mostactivemanagersAll
                // list_MostInActivemanagers = state.mostinactivemanagersAll
            }
            if(state.inputSearch){
                var re = new RegExp(state.inputSearch, 'gi')
                list_MostEngage = _.filter(list_MostEngage, (item):any => {
                    if (item.team.match(re)){
                        return true
                    }
                });
                list_RetentionRisks = _.filter(list_RetentionRisks, (item):any => {
                    if (item.team.match(re)){
                        return true
                    }
                });
                list_MostImprove = _.filter(list_MostImprove, (item):any => {
                    if (item.team.match(re)){
                        return true
                    }
                });
                list_MostCritical = _.filter(list_MostCritical, (item):any => {
                    if (item.team.match(re)){
                        return true
                    }
                });
                // list_MostActivemanagers = _.filter(list_MostActivemanagers, (item):any => {
                //     if (item.team.match(re)){
                //         return true
                //     }
                // });
                // list_MostInActivemanagers = _.filter(list_MostInActivemanagers, (item):any => {
                //     if (item.team.match(re)){
                //         return true
                //     }
                // });
            }
            data.push(list_MostEngage.slice(0, 3))
            data.push(list_RetentionRisks.slice(0, 3))
            data.push(list_MostImprove.slice(0, 3))
            data.push(list_MostCritical.slice(0, 3))
            // data.push(list_MostActivemanagers.slice(0, 3))
            // data.push(list_MostInActivemanagers.slice(0, 3))
            return data
        },
        searchByTeam({commit,dispatch}:any){
            dispatch('reponseSearchAll').then((result) => {
                commit('setMostEngageCheck', result[0])
                commit('setRetentionRisksCheck',result[1])
                commit('setMostImproveCheck',result[2])
                commit('setMostCriticalCheck',result[3])
                // commit('setMostActivemanagersCheck',result[4])
                // commit('setMostInActivemanagersCheck',result[5])
            });
        },
        searchInput({commit,dispatch}:any){
            dispatch('reponseSearchAll').then((result) => {
                commit('setMostEngageCheck', result[0])
                commit('setRetentionRisksCheck',result[1])
                commit('setMostImproveCheck',result[2])
                commit('setMostCriticalCheck',result[3])
                // commit('setMostActivemanagersCheck',result[4])
                // commit('setMostInActivemanagersCheck',result[5])
            });
        },
    },
    getters: {
        team: (state:any) => {
            return state.mostengage
        },
        mostengage: (state:any) => {
            return state.mostengage
        },
        retentionrisks: (state:any) => {
            return state.retentionrisks
        },
        mostimprove: (state:any) => {
            return state.mostimprove
        },
        mostcritical: (state:any) => {
            return state.mostcritical
        },
        // mostactivemanagers: (state:any) => {
        //     return state.mostactivemanagers
        // },
        // mostinactivemanagers: (state:any) => {
        //     return state.mostinactivemanagers
        // },
        selectTeam: (state:any) => {
            return state.team_id
        },
        inputSearch: (state:any) => {
            return state.inputSearch
        },
        dateshow: (state:any) => {
            return state.dateshow
        },
    }
  }